// basejs
import $ from 'jquery';
import * as noUiSlider from './form.range.js';

$(document).ready(function () {
	var
		is_mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

	const breakpoints = {
		mobile: 478,
		laptop: 1080,
		desktop: 1920,
	}

	const showDialog = (_dialogID) => {
		const thisDialog = $('#' + _dialogID);
		const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
		const body = document.body;
		thisDialog.addClass('is-active');
		thisDialog.animate({
			height: '100%',
			padding: '20px'
		}, 250, $.bez([0.8, 1, 0.9, 1]));
		body.style.position = 'fixed';
		body.style.top = `-${scrollY}`;
	};
	const closeDialog = (_dialogID) => {
		const thisDialog = $('#' + _dialogID);
		const body = document.body;
		const scrollY = body.style.top;
		thisDialog.animate({
			height: '0',
			padding: '0'
		}, 250, $.bez([0.8, 1, 0.9, 1]), () => { thisDialog.removeClass('is-active'); });
		body.style.position = '';
		body.style.top = '';
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
	}

	let windowHeight = window.innerHeight;
	let windowWidth = window.innerWidth;

	if (innerWidth > breakpoints.laptop) {
		$(window).click(function () {
			//Hide the menus if visible
			$(".navbar-item.has-dropdown").removeClass("is-active");
			$(".navbar__background").removeClass("is-active");
			$(".navbar-item.has-dropdown .navbar-dropdown").removeClass("is-active").css("display", "none");
		});
	}

	// open/close menu func
	var openFunc = function (event) {
		const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
		const body = document.body;
		event.data.container.delay(50).animate({
			width: 270,
			'border-left-width': 2,
		}, 250, $.bez([0.8, 1, 0.9, 1]));
		event.data.closeButton.delay(100).animate({
			right: 30
		}, 250, $.bez([0.8, 1, 0.9, 1]));
		event.data.closeButton.css("display", "block");
		// event.data.overlay.css("display", "block");
		event.data.overlay.delay(50).animate({
			height: '100vh'
		}, 150, $.bez([0.8, 1, 0.9, 1]));
		body.style.position = 'fixed';
		body.style.top = `-${scrollY}`;
	}

	var closingFunc = function (event) {
		const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
		const body = document.body;
		event.data.container.delay(50).animate({
			width: 0,
			'border-left-width': 0,
		}, 250, $.bez([0.8, 1, 0.9, 1]));

		event.data.closeButton.delay(100).animate({
			right: -30
		}, 250, $.bez([0.8, 1, 0.9, 1]));
		event.data.closeButton.css("display", "none");
		event.data.overlay.delay(50).animate({
			height: 0
		}, 150, $.bez([0.8, 1, 0.9, 1]));
		body.style.position = '';
		body.style.top = '';
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
	}

	// Меню Записаться на сервис/Записаться на звонок
	var callMenu = $("#navbarEnd");
	var closeCallButton = callMenu.find(".closeModal");
	var callMenuOverlay = callMenu.find(".navbarEnd-overlay");
	var navbarEndData = {
		container: callMenu,
		closeButton: closeCallButton,
		overlay: callMenuOverlay,
	};

	// // Open
	$(".navbar-button-call").on("click", navbarEndData, function (e) { openFunc(e); });
	// Close
	callMenuOverlay.on("mouseup", navbarEndData, function (e) { closingFunc(e); });
	closeCallButton.on("click", navbarEndData, function (e) { closingFunc(e); });

	$(".al_menu-switcher").on("click", function (event) {
		if (is_mobile) {
			showDialog($(this).data('target'));
		}
	});

	$(".al_menu-wrapper .al_menu-submenu-back").on("click", function (event) {
		closeDialog($(this).data('target'));
	});

	// dropdown элементы меню
	var navbarDropdownEls = $(".navbar-item.has-dropdown");
	var navElObj = {};
	for (const el of navbarDropdownEls) {
		navElObj[el.id] = el.id;
	}

	$(".navbar-container .al_menu-submenu-back").on("click", function (event) {
		this.style.right = '-100px';
		navbarDropdownEls.each(function (idx) {
			if ($(this).hasClass("is-active")) {
				$(this).removeClass("is-active");
				$(this).find(".navbar-dropdown").removeClass("is-active");
			}
		});
	});

	$(".al_menu-submenu-close").on("click", function (event) {
		closeDialog($(this).data('target'));
		$(".navbar-container .al_menu-submenu-back")[0].style.right = '-100px';
		navbarDropdownEls.each(function (idx) {
			if ($(this).hasClass("is-active")) {
				$(this).removeClass("is-active");
				$(this).find(".navbar-dropdown").removeClass("is-active");
			}
		});
	});

	navbarDropdownEls.on("click", function (event) {
		event.stopPropagation();

		var
			nav_background = $(".navbar__background"),
			dropdown = $(this).find(".navbar-dropdown"),
			notThisEl = navbarDropdownEls.filter((el) => navbarDropdownEls[el].id !== navElObj[this.id]);

		switch (true) {
			// При клике на уже открытую вкладку
			case $(this).hasClass("is-active"):
				$(this).toggleClass("is-active");
				if (window.innerWidth > breakpoints.laptop) {
					nav_background.removeClass("is-active");
				}
				dropdown.removeClass("is-active");
				$(".navbar-container .al_menu-submenu-back")[0].style.right = '-100px';

				break;
			// При клике на другую рандомную, с удалением is-active у остальных
			case !($(this).hasClass("is-active")):
				$(this).toggleClass("is-active");
				if (window.innerWidth > breakpoints.laptop) {
					nav_background.addClass("is-active");
				}
				dropdown.addClass("is-active");
				$(".navbar-container .al_menu-submenu-back")[0].style.right = '15px';
				notThisEl.map((el) => {
					if (notThisEl[el].classList.contains("is-active")) {
						notThisEl[el].classList.remove("is-active");
						notThisEl[el].querySelector(".navbar-dropdown").classList.remove("is-active");
					}
				})

				break;
		}
	});

	var moneyFormat = wNumb({
		decimals: 0,
		thousand: ",",
		prefix: ""
	});

	var rangeSlider = document.getElementById("slider-range");
	var moneyFormat = wNumb({
		decimals: 0,
		thousand: ",",
		prefix: ""
	});

	if (rangeSlider) {

		var startRange = Number(document.getElementById("slider-range-value1").getAttribute("filter-value"));
		var endRange = Number(document.getElementById("slider-range-value2").getAttribute("filter-value"));
		var minValue = Number(document.getElementById("slider-range-value1").getAttribute("value"));
		var maxValue = Number(document.getElementById("slider-range-value2").getAttribute("value"));

		if (minValue === 0 && maxValue === 0) {
			noUiSlider.create(rangeSlider, {
				start: [0, 1],
				step: 1,
				range: {
					min: 0,
					max: 1
				},
				format: moneyFormat,
				connect: true
			});
		} else {
			noUiSlider.create(rangeSlider, {
				start: [startRange ? startRange : minValue, endRange ? endRange : maxValue],
				step: 1,
				range: {
					min: [minValue],
					max: [maxValue]
				},
				format: moneyFormat,
				connect: true
			});
		}

		rangeSlider.noUiSlider.on("update", function (values, handle) {
			document.getElementById("slider-range-value1").innerHTML = values[0];
			document.getElementById("slider-range-value2").innerHTML = values[1];
			document.getElementsByName("min-value")[0].setAttribute("value", moneyFormat.from(values[0]));
			document.getElementsByName("max-value")[0].setAttribute("value", moneyFormat.from(values[1]));
		});
	}

	if (document.querySelector('.filter-button')) {

		document.querySelector('.filter-search').addEventListener('click', e => {
			let newPathname = '',
				selectedItems = document.querySelectorAll('.psuedo_select'),
				minPrice = Number(document.getElementById('slider-range-value1').getAttribute('value')),
				maxPrice = Number(document.getElementById('slider-range-value2').getAttribute('value')),
				priceBetween = [
					Number(document.getElementById('slider-range-value1').innerText.replace(/,/g, '')),
					Number(document.getElementById('slider-range-value2').innerText.replace(/,/g, ''))
				],
				loc = document.location.origin;

			selectedItems.forEach(el => {
				if (el.querySelector('.selected').innerText) {
					let brandOptions = el.querySelectorAll('#filter_brand .option');
					let filterBrand = [...brandOptions].filter((opt) => opt.innerText === el.querySelector('.selected').innerText);

					if (filterBrand.length > 0) {
						newPathname += el.getAttribute('id') + '=' + filterBrand[0].getAttribute('data-value') + '&';
					}

					if (!(el.getAttribute('id') === 'filter_brand')) {
						newPathname += el.getAttribute('id') + '=' + el.querySelector('.selected').innerText + '&';
					}
				}
			})

			if (priceBetween[0] !== minPrice || priceBetween[1] !== maxPrice) {
				newPathname += 'filter_price_from=' + priceBetween[0] + '&filter_price_to=' + priceBetween[1];
			}

			console.log(newPathname);
			if (newPathname) {
				document.location.href = loc + '/catalog/?' + newPathname;
			}
		});

		if (document.querySelector('.filter-clear')) {
			document.querySelector('.filter-clear').addEventListener('click', e => {
				let selectedItems = document.querySelectorAll('.psuedo_select'),
					minPrice = Number(document.getElementById('slider-range-value1').getAttribute('value')),
					maxPrice = Number(document.getElementById('slider-range-value2').getAttribute('value')),
					priceBetween = [
						Number(document.getElementById('slider-range-value1').innerText.replace(/,/g, '')),
						Number(document.getElementById('slider-range-value2').innerText.replace(/,/g, ''))
					];

				selectedItems.forEach(el => {
					if (el.querySelector('.selected').innerText) {
						document.location.href = document.location.origin + document.location.pathname;
					}
				});

				if (priceBetween[0] !== minPrice || priceBetween[1] !== maxPrice) {
					document.location.href = document.location.origin + document.location.pathname;
				}
			});
		}

		let filter = $('.filter-mobile-only');
		document.querySelector('.filter-open').addEventListener('click', e => {
			e.preventDefault;
			filter.animate({
				height: '100%'
			}, 150, $.bez([0.8, 1, 0.9, 1]));
			document.documentElement.style.overflow = 'hidden';
			document.querySelector('.site-header__content-wrapper').style.zIndex = '30';
		});

		document.querySelector('.filter-mobile-only__button-back').addEventListener('click', e => {
			e.preventDefault;
			filter.animate({
				height: '0'
			}, 150, $.bez([0.8, 1, 0.9, 1]));
			document.documentElement.style.overflow = '';
			document.querySelector('.site-header__content-wrapper').style.zIndex = '0';
		});
	}


	// Табы 
	const tabs = document.querySelector('.tabs');
	const tabsBtn = document.querySelectorAll('.tabs__btn');
	const tabsContent = document.querySelectorAll('.tabs__content');

	if (tabs) {
		tabs.addEventListener('click', (e) => {
			if (e.target.classList.contains('tabs__btn')) {
				const tabsPath = e.target.dataset.tabsPath;

				console.log(e.target);
				console.log(e.target.dataset);
				tabsHandler(tabsPath);
			}
		});
	}

	const tabsHandler = (path) => {
		tabsBtn.forEach(el => { el.classList.remove('tabs__btn--active') });
		document.querySelector(`[data-tabs-path="${path}"]`).classList.add('tabs__btn--active');

		tabsContent.forEach(el => { el.classList.remove('tabs__content--active') });
		document.querySelector(`[data-tabs-target="${path}"]`).classList.add('tabs__content--active');
	}


	/* https://css-tricks.com/restart-css-animation/ */
	/* Обнуление CSS анимации */
	if (document.querySelector('.maintenance-title')) {

		let elemsToggle = document.getElementsByClassName('maintenance-title');
		let elemsToggleArr = [...elemsToggle];

		elemsToggleArr.forEach((item) => {
			let elemRestart = item.nextElementSibling;
			item.addEventListener('click', e => {
				e.preventDefault;
				elemRestart.classList.remove("maintenance-container");
				void elemRestart.offsetWidth;
				elemRestart.classList.add("maintenance-container");
			});
		})
	}

	// $(window).scroll(function () {
	// 	if (!is_mobile) {
	// 		var scrollTop = $(window).scrollTop();
	// 		$(".site-header__content-wrapper").css("bottom", -scrollTop);
	// 	}
	// });
});